import { _APP_STORE } from '@/core/values/app.values';
import { FOOTER_TYPE } from '@/core/values/core.values';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-layout-basic'
})
class EdLayoutBasic extends Vue {

  @Prop() readonly height: number;
  @Prop({default: true}) readonly loadModalContainer: boolean;
  @Prop({ default: true }) readonly footer: boolean;
  @Prop({ default: true }) readonly isShowMenu: boolean;
  @Prop({ default: false }) readonly isPortal: boolean;

  public headerHeight: number = 0;

  get layoutStyle() {
    let res: any = {};
    if(this.height) res.height = this.height;
    return res;
  }

  get marginContent(): any {
    return { marginTop: `${this.headerHeight}px` };
  }

  get hasHeader(): boolean {
    return this.$store.state.AppStore.header.visible;
  }

  get hasHiddenMenu(): boolean {
    return this.isShowMenu;
  }

  get contentMinHeight(): any {
    let footerType = this.$store.state.AppStore.footer.type;
    let footerHeight = 100;
    switch(footerType) {
      case FOOTER_TYPE.COMPACT: 
        footerHeight = 40;
      break;
      case FOOTER_TYPE.NONE: 
        footerHeight = 0;
      break;
      default:
        footerHeight = 100 + (window.innerWidth <= 640 ? 25 : 0);
      break;
    }
    return { minHeight: `calc(100% - ${footerHeight + this.headerHeight}px)` };
  }

  get portalContentStyle() {
    if(this.isPortal) {
      return {
        height: '100%'
      }
    }
    return {
      ...this.marginContent,
      ...this.contentMinHeight
    }
  }

  setHeaderHeight() {
    let header = document.getElementById('eduac-layout-header');
    this.headerHeight = header ? header.offsetHeight : 0;
  }

  mounted() {
    this.$App.Store.setSidebarButton(false);
    window.addEventListener('resize', this.setHeaderHeight);
    setTimeout(this.setHeaderHeight, 100);
  }

}

export default Vue.component('ed-layout-basic', EdLayoutBasic);
